import { useElectronAPI } from "@/react/hooks/utils/useElectronAPI";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { CommunityLogoProps } from "@circle-react-shared/CommunityLogo";
import { CommunityLogo } from "@circle-react-shared/CommunityLogo";

export interface CommunitySectionPresentationProps extends CommunityLogoProps {
  href?: string;
  isActive?: boolean;
  name?: string;
}

export const CommunitySectionPresentation = ({
  isActive = false,
  href = "#",
  name,
  ...rest
}: CommunitySectionPresentationProps) => {
  const { isElectron, electronAPI } = useElectronAPI();

  if (isElectron) {
    const handleClick = () => {
      electronAPI?.changeCommunity({
        name,
        href,
      });
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleClick();
      }
    };

    return (
      <button
        type="button"
        data-testid="community-switcher-link"
        className={classNames(
          "switcher__icon hover:bg-c-sidebar-hover focus:bg-c-sidebar-hover !m-0 flex items-center justify-center rounded-xl border-2 border-transparent transition-colors duration-150",
          {
            "active border-secondary": isActive,
          },
        )}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <CommunityLogo includeName={false} name={name} {...rest} />
      </button>
    );
  }

  return (
    <a
      data-testid="community-switcher-link"
      className={classNames(
        "switcher__icon hover:bg-c-sidebar-hover focus:bg-c-sidebar-hover !m-0 flex items-center justify-center rounded-xl border-2 border-transparent transition-colors duration-150",
        {
          "active border-secondary": isActive,
        },
      )}
      href={href}
      aria-label={name}
    >
      <CommunityLogo includeName={false} name={name} {...rest} />
    </a>
  );
};
